define('SC.ThreadsThemeExtension.Shopping', [
  'SC.ThreadsThemeExtension.ApplicationSkeleton.Layout',
  'SC.ThreadsThemeExtension.Header',
  'SC.ThreadsThemeExtension.HeaderLogo',
  'SC.ThreadsThemeExtension.Footer',
  'SC.ThreadsThemeExtension.Home',
  'SC.ThreadsThemeExtension.HomeCMS',
  'SC.ThreadsThemeExtension.ItemRelations.SC.Configuration',
  'SC.ThreadsThemeExtension.ErrorManagement.PageNotFound.View',
  'SC.ThreadsThemeExtension.LoadWebFont',
  'SC.ThreadsThemeExtension.Common.Configuration',
  'SC.ThreadsThemeExtension.Common.LayoutHelper',
  'SC.ThreadsThemeExtension.Common.UtilitiesHelper',
  'Utils',
  'underscore'
], function threadsThemeExtensionShoppingEntryPoint(
  ThreadsThemeApplicationLayout,
  ThreadsThemeExtHeader,
  ThreadsThemeExtHeaderLogo,
  ThreadsThemeExtFooter,
  ThreadsThemeExtHome,
  ThreadsThemeExtHomeCMS,
  ThreadsThemeExtItemRelations,
  ThreadsThemeExtErrorManagementPageNotFound,
  ThreadsThemeExtLoadWebFont,
  Configuration,
  LayoutHelper,
  UtilitiesHelper,
  Utils,
  _
) {
  'use strict';
  return {
    mountToApp: function (container) {
      UtilitiesHelper.toggleViewportToMobileSupport();
      Configuration.setEnvironment(container.getComponent('Environment'));
      LayoutHelper.setLayoutComponent(container.getComponent('Layout'));
      Utils.initBxSlider = _.initBxSlider = _.wrap(
        _.initBxSlider,
        function initBxSlider(fn) {
          var autoPlayCarousel = Configuration.get('home.autoPlayCarousel');
          var carouselSpeed = Configuration.get('home.carouselSpeed');
          if (
            arguments.length !== 0 &&
            arguments[1] &&
            arguments[1][0] &&
            arguments[1][0].id === 'home-image-slider-list'
          ) {
            arguments[2] = _.extend(arguments[2], {
              auto: autoPlayCarousel,
              pause: carouselSpeed
            });
          }
          return fn.apply(this, _.toArray(arguments).slice(1));
        }
      );
      ThreadsThemeApplicationLayout.loadModule();
      ThreadsThemeExtHeader.loadModule();
      ThreadsThemeExtHeaderLogo.loadModule(container);
      ThreadsThemeExtFooter.loadModule();
      ThreadsThemeExtHome.loadModule();
      ThreadsThemeExtHomeCMS.mountToApp(container);
      ThreadsThemeExtItemRelations.loadModule();
      ThreadsThemeExtErrorManagementPageNotFound.loadModule();
      ThreadsThemeExtLoadWebFont.loadModule();
    }
  };
});
